// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"3cbf3df1","787":"d1b4dcdc","843":"1927dc21"}[chunkId] + ".chunk.js";
};